import type { JSX } from 'react';
import { useState } from 'react';
import { api, ApiError } from '../lib/api';
import { Button, Card, Field, Input, Wordmark } from './ui';

/**
 * v1: geteiltes Passwort plus ein frei gewaehlter Name.
 *
 * Der Name ist ausdruecklich keine Authentifizierung — er beantwortet nur die
 * Frage "wer hat den Bot gestartet". Das steht auch so im Formular, damit
 * niemand ihn fuer eine Zugangskontrolle haelt.
 */
export function LoginView({ onLoggedIn }: { onLoggedIn: (name: string) => void }): JSX.Element {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent): Promise<void> => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const result = await api.login(password, name);
      onLoggedIn(result.user.name);
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : String(cause));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-dvh items-center justify-center p-5">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex justify-center">
          <Wordmark />
        </div>

        <Card>
          <h1 className="text-xl text-fg">Anmelden</h1>
          <p className="mt-1 text-sm text-fg-muted">
            Internes Werkzeug, um AVAs in Teams-Meetings zu schicken.
          </p>

          <form onSubmit={(e) => void submit(e)} className="mt-5 space-y-4">
            <Field
              label="Dein Name"
              htmlFor="name"
              hint="Wird bei jeder Session als „gestartet von“ angezeigt und in den Meeting-Chat geschrieben. Keine Zugangskontrolle."
            >
              <Input
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoComplete="username"
                required
              />
            </Field>

            <Field label="Passwort" htmlFor="password">
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </Field>

            {error !== null && (
              <p className="rounded-lg bg-danger/10 px-3 py-2 text-sm text-danger">{error}</p>
            )}

            <Button type="submit" variant="primary" disabled={busy} className="w-full">
              {busy ? 'Anmelden …' : 'Anmelden'}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
